import { AlertTriangle } from 'lucide-react';
import { createPortal } from 'react-dom';

export default function ConfirmDialog({ isOpen, title, message, confirmLabel = 'Supprimer', onConfirm, onCancel }) {
  if (!isOpen) return null;
  return createPortal(
    <div
      style={{ position: 'fixed', inset: 0, zIndex: 2000, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(10,18,40,0.6)', backdropFilter: 'blur(4px)', padding: '20px' }}
      onClick={onCancel}
    >
      <div
        style={{ background: 'white', borderRadius: '20px', padding: '28px 24px', width: '100%', maxWidth: '360px', boxShadow: '0 24px 64px rgba(10,18,40,0.25)', animation: 'fadeSlideIn 0.2s ease' }}
        onClick={e => e.stopPropagation()}
      >
        <div style={{ width: '48px', height: '48px', borderRadius: '14px', background: '#fff1f2', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '16px' }}>
          <AlertTriangle size={22} color="#be123c" />
        </div>
        <div className="ui-sheet-title" style={{ marginBottom: '8px' }}>{title}</div>
        <div style={{ fontSize: '13px', color: '#64748b', lineHeight: 1.6, marginBottom: '24px' }}>{message}</div>
        <div style={{ display: 'flex', gap: '10px' }}>
          <button onClick={onCancel}
            style={{ flex: 1, padding: '11px', borderRadius: '10px', border: '1.5px solid #e2e8f0', background: 'white', fontSize: '13px', fontWeight: 600, color: '#6b7280', cursor: 'pointer' }}>
            Annuler
          </button>
          <button onClick={onConfirm}
            style={{ flex: 1, padding: '11px', borderRadius: '10px', border: 'none', background: 'linear-gradient(135deg, #be123c, #9f1239)', color: 'white', fontSize: '13px', fontWeight: 700, cursor: 'pointer', boxShadow: '0 4px 12px rgba(190,18,60,0.3)' }}>
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
